import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      // 调用函数,刷新页面重新初始化,token不会丢失
      key: 'HEIMA_TOUTIAO', // 默认值是vuex, 可以修改key
      storage: window.sessionStorage, // 改为会话存储
      reducer ({ route }) {
        // 只存储token,而不包括a:1这个数据
        // const { tokenObj, myChannels} = state
        // console.log(state) // 一个对象,包括a数据的对象和token数据的对象
        return { route }
      }
    })
  ],
  state: {
    route: '/home'
  },
  getters: {
  },
  mutations: {
    setRoutr (state, payload) {
      state.route = payload
    }
  },
  actions: {
  },
  modules: {
  }
})
